import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classes from './HousingHelperBanner.module.scss';
import PageBanner from '@/components/Banner/PageBanner';
import Link from '@/helpers/Link';
import ODAS from '@/utils/api/odas';
import t from '@/utils/Language/Promotions-translations';
import useLocation from '@/hooks/useLocation';

const HOUSING_HELPER_REGIONS = ['sf', 'la'];

const HousingHelperBanner = ({ opportunity }) => {
  const [eligible, setEligible] = useState(false);
  const { locationContext } = useLocation();
  const { locationHelpers } = locationContext;

  // Show the banner only for Housing resources in a region where the Housing Helper
  // operates (SF / LA). The region comes from the resource's primary location when it has
  // one; a region-only resource (no locations) is matched by its own region attribute.
  useEffect(() => {
    if (opportunity?.areas?.[0] !== 'Housing') {
      setEligible(false);
      return;
    }

    const location = opportunity?.locations?.find((loc) => loc.is_primary) || opportunity?.locations?.[0];

    if (!location?.lat || !location?.long) {
      // ODRS serializes a region-only resource's region as free text (e.g.
      // "San Francisco, California") without its geocoded coordinates, so match the text
      // against the target regions' county names instead of calling /api/closest/region.
      const regionText = opportunity?.region?.toLowerCase() || '';
      setEligible(
        HOUSING_HELPER_REGIONS.some((regionId) => {
          const county = locationHelpers?.getNamedLocation(regionId)?.county;
          return county && regionText.includes(county.toLowerCase());
        })
      );
      return;
    }

    ODAS.get('/api/closest/region', { lat: location.lat, lng: location.long })
      .then((response) => setEligible(!response?.data?.is_default && HOUSING_HELPER_REGIONS.includes(response?.data?.region)))
      .catch(() => setEligible(false));
  }, [opportunity, locationHelpers]);

  if (!eligible) {
    return null;
  }

  return (
    <PageBanner type="promotion" icon={['fas', 'house-user']} iconColor="blue">
      <strong>{t('Need help finding housing resources?')}</strong>{' '}
      <Link href="/assessments/housing-helper" className={classes.housingHelperLink}>
        {t('Head to the Housing Helper to get started')}
        <FontAwesomeIcon icon={['fas', 'arrow-right']} />
      </Link>
    </PageBanner>
  );
};

export default HousingHelperBanner;
